import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { usePetPhotoUrl } from '../../hooks/usePetPhotoUrl';

import './petIcon.scss';

export const PetIcon = ({ profilePic, fullPolicyNumber, species, gender, isChecked }) => {
  const profilePicUrl = usePetPhotoUrl(profilePic, fullPolicyNumber);
  const iconCssClass = useMemo(() => {
    if (species === 'Canine') {
      return `dog-profile-${gender}`.toLowerCase();
    }
    return `cat-profile-${gender}`.toLowerCase();
  }, [species, gender]);

  return (
    <span className={`petIcon ${isChecked ? 'active' : ''}`}>
      <Icon icon={iconCssClass} />
      {profilePicUrl && profilePicUrl.indexOf('placeholderImage') === -1 && (
        <img
          src={profilePicUrl}
          alt=""
          className="profilePic"
        />
      )}
    </span>
  );
};

PetIcon.propTypes = {
  profilePic: PropTypes.string,
  fullPolicyNumber: PropTypes.string,
  species: PropTypes.oneOf(['Canine', 'Feline']),
  gender: PropTypes.oneOf(['Male', 'Female']),
  isChecked: PropTypes.bool
};
